import { LANG_PATTERN } from '../../constants';

export const removeLangFromPathname = (pathname: string) =>
  pathname.replace(LANG_PATTERN, '/$`');
